module.exports = __webpack_public_path__ + "img/certificate.7285fc5.svg";